import React from "react";

const userState = {
  user: null,
};
const userStateContext = React.createContext(userState);

export default userStateContext;
